export const Routes = {
  Screening: '/screening/list',
  Movie: '/screening/movie',
  Reservation: {
    Places: '/reservation/places',
    Food: '/reservation/food',
  },
  Payment: {
    Form: '/payment/form',
    Success: '/payment/status/success',
    Fail: '/payment/status/fail',
    Status: '/payment/status',
  },
  NotFound: '/not-found',
  TechnicalBreak: '/technical-break',
  Profile: '/profile',
  SignUp: '/sign-up',
  SignIn: '/sign-in',
  ReservationMethod: '/reservation-method',
  PasswordReset: '/password-reset',
};
